/**
 * Card component
 */

var cards = {
    options: {
        cardItem: '.js-cardItem',
        cardItemButton: '.js-cardItemButton',
        cardItemContent: '.js-cardItemToggleContent',
    },

    init: function() {
        var self = this;

        document.querySelectorAll(self.options.cardItem).forEach(function(item) {
            var button = item.querySelector(self.options.cardItemButton);
            if (!button) return;

            button.addEventListener('click', function() {
                var content = item.querySelector(self.options.cardItemContent);
                if (content) {
                    content.classList.toggle('hidden');
                    button.classList.toggle('-rotate-90', !content.classList.contains('hidden'));
                }
            });
        });
    },
};

export { cards };
